import { useEffect, useState } from "react";
import { useLanguage } from "../i18n/LanguageContext";
import api from "../lib/api";

function toDateStr(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export const TimeStep = ({ serviceId, date, selectedTime, onSelect }) => {
  const { t } = useLanguage();
  const [slots, setSlots] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!serviceId || !date) return;
    setSlots(null);
    setError("");
    api
      .get("/availability/slots", { params: { service_id: serviceId, date: toDateStr(date) } })
      .then(({ data }) => setSlots(data.slots))
      .catch(() => {
        setSlots([]);
        setError(t("booking.errors.serverError"));
      });
  }, [serviceId, date, t]);

  return (
    <div data-testid="booking-time-step">
      <h2 className="font-serif text-2xl text-white mb-6">{t("booking.selectTime")}</h2>
      {slots === null && <p className="text-white/50">{t("booking.loadingSlots")}</p>}
      {error && <p className="text-red-400 text-sm mb-4">{error}</p>}
      {slots && slots.length === 0 && !error && <p data-testid="booking-no-slots" className="text-white/60">{t("booking.noSlots")}</p>}
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
        {slots && slots.map((s) => (
          <button
            key={s.start}
            data-testid={`booking-time-slot-${s.start}`}
            onClick={() => onSelect(s.start)}
            className={`py-3 text-sm border rounded-lg transition-colors ${
              selectedTime === s.start ? "border-gold bg-gold/10 text-gold" : "border-white/10 text-white/80 hover:border-white/30"
            }`}
          >
            {s.start}
          </button>
        ))}
      </div>
    </div>
  );
};
